import { useCallback } from 'react'

import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { sendHubspotEvent } from '@services/hubspotEvent/api'
import type { HubspotEventInput } from '@services/hubspotEvent/types'

import { useActiveCompany } from './useActiveCompany'

export function useTrackHubspotEvent() {
  const location = useLocation()
  const activeCompany = useActiveCompany()
  const validActionIds = useSelector((state: Store) => state.dashboard.common.hubspot_event_actions)

  return useCallback(
    (event: HubspotEventInput) => {
      if (!validActionIds?.some(a => a.id === event.action_id)) return
      if (!activeCompany) return

      sendHubspotEvent({
        ...event,
        company_id: activeCompany.id,
        hs_page_url: event.hs_page_url ?? window.location.origin + location.pathname,
      }).catch(() => undefined)
    },
    [activeCompany, location.pathname, validActionIds]
  )
}
